import esContent from './onboarding.es';

export default {
  ...esContent,
};
